/**
 * 全局兜底toast文案
 */
export var ERROR_TEXT = '前方拥堵，请稍后重试';